import React from "react";

import classNames from "classnames";

import { makeStyles, useTheme } from "@material-ui/core/styles";

import useMediaQuery from '@material-ui/core/useMediaQuery';

import ScrollAnimation from "react-animate-on-scroll";
import AppleIcon from '@material-ui/icons/Apple';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import AndroidIcon from '@material-ui/icons/Android';
import WebIcon from '@material-ui/icons/Web';
import ViewCarousel from "@material-ui/icons/ViewCarousel";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import iphone from "images/iphone.png"

import FeatureSectionStyle from "./FeatureSectionStyle";


const useStyles = makeStyles(FeatureSectionStyle);


const FeatureSection = () => {
    const classes = useStyles();
    const theme = useTheme();

    const underMd = useMediaQuery(theme.breakpoints.down('md'));
    const underXs = useMediaQuery(theme.breakpoints.down('xs'));
    const center = classNames(classes.mlAuto, classes.mrAuto);

    return (
        <div className={classes.features4}>
            <GridContainer>
                <GridItem
                    xs={8} sm={8} md={8}
                    className={classNames(classes.mlAuto, classes.mrAuto, classes.textCenter)}>
                    <h2 className={classNames(classes.title)} style={{fontSize: underXs ? '1.8rem' : null}}>
                        <ScrollAnimation animateIn="fadeIn" duration={1} delay={1.0} animateOnce={true}>
                            클라스카와 함께 하시면
                        </ScrollAnimation>
                    </h2>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={5} className={underXs ? center : classes.mlAuto}>
                    <ScrollAnimation animateIn={underMd ? "fadeIn" : "fadeInLeftSmall"} duration={1} offset={150} animateOnce={true}>
                        <InfoArea
                            icon={AccessibilityNewIcon}
                            title="노후 대책"
                            description="고령층 차주에겐 노후 대책 수입과 이동의 자유"
                            iconColor="black"
                        />
                        <InfoArea
                            icon={BeachAccessIcon}
                            title="경제적 교통수단"
                            description="청년 이용자에겐 경제적인 교통수단 제공과 보람"
                            iconColor="success"
                        />
                    </ScrollAnimation>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={5} className={underXs ? center : classes.mrAuto}>
                    <ScrollAnimation animateIn={underMd ? "fadeIn" : "fadeInRightSmall"} duration={1} animateOnce={true}>
                        <InfoArea
                            icon={WebIcon}
                            title="고객 유치"
                            description="얼라이언스 기업은 고객 확보를 통한 매출 증대"
                            iconColor="info"
                        />
                        <InfoArea
                            icon={ViewCarousel}
                            title="세대공감"
                            description="양극화된 사회에는 세대공감으로 소통을"
                            iconColor="danger"
                        />
                    </ScrollAnimation>
                </GridItem>
            </GridContainer>
        </div>
    )
};

export default FeatureSection;
